import { useEffect } from 'react'
import L, { Map } from 'leaflet'
import { Breakpoint } from '../../../shared/hooks/useBreakpoint'
import useWindowWidth from '../../../shared/hooks/useWindowWidth'
import {
  MAP_MAX_BOUNDS,
  MAP_DEFAULT_CENTER,
} from '../../../shared/components/LeafletMap/LeafletMap'
import { useMapContext } from '../../../shared/contexts/map/MapContext'

const getLayerBounds = (layers: L.Layer[]) =>
  layers
    .map((layer) => {
      if ((layer as any).getBounds) {
        return (layer as any).getBounds()
      }

      if ((layer as any).getLatLng) {
        return (layer as any).getLatLng()
      }

      return undefined
    })
    .filter(Boolean)

const useCenterOnFeature = (mapInstance: Map | null) => {
  const { featureLayers, setOutOfBounds } = useMapContext()
  const width = useWindowWidth()

  useEffect(() => {
    const featureBounds = getLayerBounds(featureLayers ?? [])
    const outOfBounds = featureBounds.length > 0 && !MAP_MAX_BOUNDS.contains(featureBounds)

    setOutOfBounds(outOfBounds)

    const { x, y } = mapInstance?.getSize() ?? { x: 0, y: 0 }

    if (mapInstance && featureBounds.length > 0 && x > 0 && y > 0) {
      if (outOfBounds) {
        mapInstance.setView(MAP_DEFAULT_CENTER, 3)
      } else {
        const maxZoom = width >= Breakpoint.Md.valueOf() ? 14 : 13

        mapInstance.fitBounds(featureBounds, { maxZoom })
      }
    }
  }, [mapInstance, featureLayers])
}

export default useCenterOnFeature
